module.exports = "### 客户简介\r\n国家中医药管理局是政府管理中医药行业的国家机构，隶属于国家卫生和计划生育委员会。国家中医药管理局领导对马兰头视频会议系统做出高度评价，在这次超过300家单位参加的培训和会议上，声音和图像均清晰流畅。"